module.exports = __webpack_public_path__ + "img/IconoVinil.43e192cd.png";